import { VendingPackageVolumeLineChart, hasChartData } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast30DaysVendingPackageVolumeLineChart } from './use-last-30-days-vending-package-volume-line-chart';

export interface Last30DaysVendingPackageVolumeLineChartProps {
    accountId: string;
}

export const Last30DaysVendingPackageVolumeLineChart = (props: Last30DaysVendingPackageVolumeLineChartProps) => {
    const { data, isLoading, subtitle } = useLast30DaysVendingPackageVolumeLineChart(props);

    return (
        <StatisticsCard
            chartKey={VendingPackageVolumeLineChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.vending.last-30-days-vending-package-volume-line-chart.title'
                    description='Title of the vending dashboard chart showing consumption volume over the last 30 days'
                    defaultMessage='Consumption volume'
                />
            }
            subtitle={subtitle}
            isLoading={isLoading}
            hasData={hasChartData(data)}>
            {hasChartData(data) && data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <VendingPackageVolumeLineChart
                        data={data}
                        minHeight={80}
                        showLabels='minimal'
                        tooltipShared
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
